import client, { unwrap } from "@/api/client";

/** GST certificate, shop proof etc. The backend only links files uploaded under this category. */
export const KYC_CATEGORY = "TENANT_KYC";
export const KYC_ACCEPT = "application/pdf,image/png,image/jpeg";

export async function uploadVerificationDocument(file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await client.post(`/files/upload?category=${KYC_CATEGORY}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return String(unwrap(res).id);
}

/**
 * Opens a stored file through a short-lived signed URL. The tab opens before the request so popup
 * blockers still treat it as part of the click.
 */
export async function openFile(fileId) {
  const tab = window.open("", "_blank");
  if (tab) tab.opener = null;
  try {
    const { url } = await client.get(`/files/${fileId}`).then(unwrap);
    if (tab) tab.location.href = url;
    else window.location.href = url;
  } catch (err) {
    tab?.close();
    throw err;
  }
}
